import { t } from '@packages/prelude'
import { indexReadonlyRecord } from 'monocle-ts/Index/ReadonlyRecord'

export const Type = t.type({
  id: t.number,
  fieldId: t.string,
  title: t.string,
  description: t.string,
  optional: t.boolean,
  greeting: t.option(t.string),
  selected: t.boolean
})

export interface Type extends t.TypeOf<typeof Type> {}

export const Lens = t.getLenses(Type)

export const greetingDataById = (id: string) => indexReadonlyRecord<Type>().index(id)

export const starGreetingsGreetingLens = (id: string) => greetingDataById(id).composeLens(Lens.greeting)

export const starGreetingsSelectedLens = (id: string) => greetingDataById(id).composeLens(Lens.selected)
